import React, { useState } from 'react';
import ButtonCardWithFunction from '../../../../Helpers/Buttons/ButtonCardWithFunction';
import NeedsCalculator from '../../../../Tools/NeedsAnalysis/NeedsCalculator';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { SESSION_STORAGE_NEEDS_ANALYSIS_KEY } from '../../../../../sessionStorage';
import './NeedsAnalysisButton.scss'
import IconHolder from '../../../../Common/IconHolder';

const white = "#ffffff";
const offWhite = "rgba(0, 0, 0, 0.01)"

const useStyles = makeStyles(theme => ({
  white: {
    color: theme.palette.primary.main,
    backgroundColor: white,
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: offWhite
    },
    '&:focus': {
      outline: 'none'
    }
  }
}));

export default function NeedsAnalysisButton(props) {
  const classes = useStyles();

  const shape = props.shape ? props.shape : 'wide';

  const title = props.title || "Needs Analysis";

  const [modalNeedsCalculatorIsOpen, setModalNeedsCalculatorIsOpen] = useState(false);

  const setCoverageAmount = (face) => {
    if (props.setCoverageAmount !== null) {
      props.setCoverageAmount(face)
    }
    else {
      sessionStorage.setItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY, face);
      window.location = "/quote/term-life-insurance/personalizing-options";
    }
  };

  const modalNeedsCalculatorFields = {
    modalNeedsCalculatorIsOpen: modalNeedsCalculatorIsOpen,
    setModalNeedsCalculatorIsOpen: setModalNeedsCalculatorIsOpen,
    setCoverageAmount: setCoverageAmount,
    minCoverageAmount: props.minCoverageAmount || 250000,
    maxCoverageAmount: props.maxCoverageAmount || 10000000,
  };

  return (
    <div className="needs-analysis-button">
      <React.Fragment>
        {props.type === "quote-screen" ?
          <Button type="submit"
            onClick={() => props.history.push('/InsuranceTools/NeedsAnalysis')}
            variant="contained"
            className={`quote-needs-button ${classes.white}`}
          >
            <IconHolder icon={props.component} viewBox="0 0 49 49" />
            <span className="name pl-3">&nbsp;{props.title ? props.title : 'NEEDS ANALYSIS'}</span>
          </Button>
          :
          <ButtonCardWithFunction id={0}
            name={title}
            onClick={() => props.history.push('/InsuranceTools/NeedsAnalysis')}
            shape={shape}
            icon={<IconHolder icon={props.component} viewBox="0 0 49 49" />

            }
            className={classes.white}
          />
        }
        <NeedsCalculator fields={modalNeedsCalculatorFields} />
      </React.Fragment>
    </div>
  );
}

NeedsAnalysisButton.propTypes = {
  minCoverageAmount: PropTypes.number,
  maxCoverageAmount: PropTypes.number,
  shape: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Product/ABLTC/RequestIllustration/SubComponents/NeedsAnalysisButton.js